import React from 'react';
import { changeSidebarState } from 'redux/slices';
import { useAppDispatch, useAppSelector } from 'redux/store';
import { ReactComponent as SidebarCollapse } from 'assets/images/sidebarCollapse.svg';
import { ReactComponent as SidebarExpand } from 'assets/images/sidebarExpand.svg';
import { SSidebarControl } from '../Sidebar.style';

const CollapseIcons = () => {
  const dispatch = useAppDispatch();
  const collapsed = useAppSelector(
    state => state.appSettings.sidebar.collapsed,
  );
  const Glyph = collapsed ? SidebarExpand : SidebarCollapse;
  return (
    <SSidebarControl
      onClick={() => dispatch(changeSidebarState({ collapsed: !collapsed }))}
    >
      <Glyph width={24} height={24} aria-hidden />
    </SSidebarControl>
  );
};

export default CollapseIcons;
